import { useMapContext } from "@/components/MindMap/index.mjs";
import openWindow from "@/script/openWindow.mjs";

export default () => {
	const map = useMapContext();
	const { mapTypeCode, prjId, sVer } = map.data;

	if ("SA_MAP" !== mapTypeCode) {
		return null;
	}

	const onClick = () => openWindow("/RevDeltaList", { prjId, sVer });

	return {
		label: "增量逆向",
		onClick,
	};
};
